<template>
    <div class="form-value">
        <div class="content-caption dashed bg-white">
            <span>申请附件信息</span>
        </div>
        <ul class="file-area input clearfix" v-if="appturnFileList.length > 0">
            <li class="file-content" style="height: 210px" v-if="appturnFile.attFlag == 0" v-for="(appturnFile, index) in appturnFileList">
                <swb-file-item :trackKey="index" :fileName="appturnFile.fileName" :fileUuid="appturnFile.fileUuid" :fileBrowseUrl="appturnFile.fileBrowseUrl" :fileDownloadUrl="appturnFile.fileBrowseUrl" :deletable="false"></swb-file-item>
                <el-input :title="appturnFile.fileName" :disabled="true" v-model="appturnFile.fileName"></el-input>
                <div class="mt5"><i v-if="appturnFile.tagName != null" class="swb-tags swb-tags-success mr5">{{appturnFile.tagName}}</i></div>
            </li>
        </ul>
        <div class="content-caption dashed bg-white">
            <span>确认附件信息</span>
        </div>
        <ul class="file-area input clearfix" v-if="appturnFileList.length > 0">
            <li class="file-content" style="height: 210px" v-if="appturnFile.attFlag == 2" v-for="(appturnFile, index) in appturnFileList">
                <swb-file-item :trackKey="index" :fileName="appturnFile.fileName" :fileUuid="appturnFile.fileUuid" :fileBrowseUrl="appturnFile.fileBrowseUrl" :fileDownloadUrl="appturnFile.fileBrowseUrl" :deletable="false"></swb-file-item>
                <el-input :title="appturnFile.fileName" :disabled="true" v-model="appturnFile.fileName"></el-input>
                <div class="mt5"><i v-if="appturnFile.tagName != null" class="swb-tags swb-tags-success mr5">{{appturnFile.tagName}}</i></div>
            </li>
        </ul>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    //
    import shareAccApi from '../../api/shareAcc';
    //
    export default {
        name: 'swb-share-acc-adjust-apply-form-file',
        desc: '配件调配附件查看',
        props: ['voucherId'],
        data: function () {
            return {
                appturnFileList: [],
            }
        },
        created: function () {
            //
            this.getAdjustApplyFormFileList();
        },
        methods: {
            getAdjustApplyFormFileList: function () {
                let self = this;
                let postData = {
                    formId: self.voucherId
                };
                let theLoad = MsgBox.loading();
                shareAccApi.getAdjustApplyFormFileList(postData, function (result) {
                    theLoad.hide();
                    if(result.type == "info") {
                        //
                        self.appturnFileList = result.data || [];
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/shareAcc/AdjustApplyFormFile.vue